import React from 'react';
import { observer } from 'mobx-react';
import { FormattedMessage, MessageDescriptor, useIntl } from 'react-intl';
import DefaultButton from '../../../../../../../global/default-button/default-button';
import OptionsButton from '../../../../../../../global/options-button/options-button';
import { EDIT_TEXT } from '../../../../../../../../constants/common-labels.constants';
import {
    MODULE_ROW_ACTIVATE_OPTION_TEXT,
    MODULE_ROW_DEACTIVATE_OPTION_TEXT,
    MODULE_ROW_LABEL_PREFIX_TEXT,
    MODULE_ROW_MY_EVENTS_LABEL_PREFIX_TEXT,
    MODULE_ROW_REMOVE_OPTION_TEXT,
    MODULE_ROW_RICH_TEXT_LABEL_PREFIX_TEXT,
    MODULE_ROW_SPEAKERS_LABEL_PREFIX_TEXT,
} from '../../../../../../event-hubs.text';
import { HubModuleType } from '../../../../../../../../api/event-hubs.dao';
import { HubModuleVM } from '../hub-module.viewmodel';
import './module-row.scss';

const MoreHorizIcon: React.FC = () => <i className='material-icons module-row__menu-icon'>more_horiz</i>;

const ROW_LABEL_PREFIX: Record<HubModuleType, MessageDescriptor> = {
    [HubModuleType.EVENTS]: MODULE_ROW_LABEL_PREFIX_TEXT,
    [HubModuleType.SPEAKERS]: MODULE_ROW_SPEAKERS_LABEL_PREFIX_TEXT,
    [HubModuleType.RICH_TEXT]: MODULE_ROW_RICH_TEXT_LABEL_PREFIX_TEXT,
    [HubModuleType.MY_EVENTS]: MODULE_ROW_MY_EVENTS_LABEL_PREFIX_TEXT,
};

type ModuleRowProps = {
    vm: HubModuleVM;
    onEdit: (vm: HubModuleVM) => void;
    onToggleActive: (vm: HubModuleVM) => void;
    onRemove: (vm: HubModuleVM) => void;
    editingDisabled?: boolean;
};

export const ModuleRow: React.FC<ModuleRowProps> = observer(props => {
    const { vm, onEdit, onToggleActive, onRemove, editingDisabled } = props;
    const intl = useIntl();
    const isActive = vm.isEnabled();

    const handleEdit = () => onEdit(vm);
    const toggleLabelText = isActive ? MODULE_ROW_DEACTIVATE_OPTION_TEXT : MODULE_ROW_ACTIVATE_OPTION_TEXT;

    const menuOptions = [
        {
            label: intl.formatMessage(toggleLabelText),
            action: () => onToggleActive(vm),
        },
        {
            label: intl.formatMessage(MODULE_ROW_REMOVE_OPTION_TEXT),
            action: () => onRemove(vm),
            danger: true,
        },
    ];

    return (
        <div className='module-row'>
            <span className='module-row__label'>
                <span className='module-row__label-prefix'>
                    <FormattedMessage {...ROW_LABEL_PREFIX[vm.getModuleType()]} />
                </span>
                <span className='module-row__label-value'>{vm.getLabel()}</span>
            </span>
            {!editingDisabled && (
                <div className='module-row__actions'>
                    <DefaultButton
                        modifier='slim'
                        className='module-row__edit-button'
                        text={<FormattedMessage {...EDIT_TEXT} />}
                        onClick={handleEdit}
                    />
                    <OptionsButton
                        isIconButton
                        icon={MoreHorizIcon}
                        options={menuOptions}
                        className='module-row__menu-button'
                        position='top'
                        align='end'
                        autoFlip
                    />
                </div>
            )}
        </div>
    );
});
